import React from 'react';
import {
  CLIENT_PROFILE_COMPONENT_TYPES,
  clientProfileRoutes,
  responsibleGamingRoutes,
} from '@atlas/routing';
import PropTypes from 'prop-types';

import ClientProfileSubRouter from 'components/ClientProfile/ClientProfileSubRouter';
import SelfRegulation from 'components/ClientProfile/ResponsibleGaming/SelfRegulation/SelfRegulation';
import SelfExclusion from 'components/ClientProfile/ResponsibleGaming/SelfExclusion/SelfExclusion';
import RealityCheck from 'components/ClientProfile/ResponsibleGaming/RealityCheck/RealityCheck';

const { responsibleGaming } = clientProfileRoutes;
const { selfRegulation, selfExclusion, realityCheck } = responsibleGamingRoutes;

const getAvailableRoutes = clientProfilePath => ({
  [CLIENT_PROFILE_COMPONENT_TYPES.SELF_REGULATION]: {
    path: `${clientProfilePath}/${responsibleGaming}/${selfRegulation}`,
    component: SelfRegulation,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.SELF_EXCLUSION]: {
    path: `${clientProfilePath}/${responsibleGaming}/${selfExclusion}`,
    component: SelfExclusion,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.REALITY_CHECK]: {
    path: `${clientProfilePath}/${responsibleGaming}/${realityCheck}`,
    component: RealityCheck,
  },
});

const ResponsibleGamingRouter = ({ tabs }) => (
  <ClientProfileSubRouter
    tabs={tabs}
    getAvailableRoutes={getAvailableRoutes}
    parentRoute={responsibleGaming}
  />
);

ResponsibleGamingRouter.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
};

export default ResponsibleGamingRouter;
